// eslint-disable
const scrollIt = (
  destination,
  duration = 200,
  easing = 'linear',
  offset = false,
  callback = () => {},
) => {
  // Predefine list of available timing functions
  // If you need more, tween js is full of great examples
  // https://github.com/tweenjs/tween.js/blob/master/src/Tween.js#L421-L737
  const easings = {
    linear(t) {
      return t;
    },
    easeInQuad(t) {
      return t * t;
    },
    easeOutQuad(t) {
      return t * (2 - t);
    },
    easeInOutQuad(t) {
      return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
    },
    easeInCubic(t) {
      return t * t * t;
    },
    easeOutCubic(t) {
      return --t * t * t + 1;
    },
    easeInOutCubic(t) {
      return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
    },
    easeInQuart(t) {
      return t * t * t * t;
    },
    easeOutQuart(t) {
      return 1 - --t * t * t * t;
    },
    easeInOutQuart(t) {
      return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
    },
    easeInQuint(t) {
      return t * t * t * t * t;
    },
    easeOutQuint(t) {
      return 1 + --t * t * t * t * t;
    },
    easeInOutQuint(t) {
      return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
    },
  };

  // Store initial position of a window and time
  // If performance is not available in your browser
  // It will fallback to new Date().getTime() - thanks IE < 10
  const start = window.pageYOffset;
  const startTime =
    'now' in window.performance ? performance.now() : new Date().getTime();
  // const startTime = typeof(window.performance['now']) == 'function' ? performance.now() : new Date().getTime();

  // Take height of window and document to resolve max scrollable value
  // Prevent requestAnimationFrame() from scrolling below maximum scrollable value
  // Resolve destination type (node or number)
  const documentHeight = Math.max(
    document.body.scrollHeight,
    document.body.offsetHeight,
    document.documentElement.clientHeight,
    document.documentElement.scrollHeight,
    document.documentElement.offsetHeight,
  );
  const windowHeight =
    window.innerHeight ||
    document.documentElement.clientHeight ||
    document.getElementsByTagName('body')[0].clientHeight;
  const scrollTop = Math.max(
    document.body.scrollTop,
    document.documentElement.scrollTop,
  );
  const destinationOffset =
    typeof destination === 'number'
      ? destination
      : Math.round(destination.getBoundingClientRect().top + scrollTop);

  // Extract header height as an offset value
  const header = document.querySelector('header');
  let destinationOffsetToScroll;
  if (offset) {
    destinationOffsetToScroll =
      documentHeight - destinationOffset < windowHeight
        ? documentHeight - windowHeight
        : destinationOffset - header.clientHeight;
  } else {
    destinationOffsetToScroll =
      documentHeight - destinationOffset < windowHeight
        ? documentHeight - windowHeight
        : destinationOffset;
  }

  // If requestAnimationFrame is not supported
  // Move window to destination position and trigger callback function
  if ('requestAnimationFrame' in window === false) {
    window.scroll(0, destinationOffsetToScroll);
    if (callback) {
      callback();
    }
    return;
  }

  // function resolves position of a window and moves to exact amount of pixels
  // Resolved by calculating delta and timing function choosen by user
  function scrollEl() {
    const now =
      'now' in window.performance ? performance.now() : new Date().getTime();
    const time = Math.min(1, (now - startTime) / duration);
    const timeFunction = easings[easing](time);
    window.scroll(
      0,
      Math.ceil(timeFunction * (destinationOffsetToScroll - start) + start),
    );

    // Stop requesting animation when window reached its destination
    // And run a callback function
    if (Math.round(window.pageYOffset) === destinationOffsetToScroll) {
      if (callback) {
        callback();
      }
      return;
    }

    // If window still needs to scroll to reach destination
    // Request another scroll invokation
    requestAnimationFrame(scrollEl);
  }

  // Invoke scroll and sequential requestAnimationFrame
  scrollEl();
};

export const scrollToItem = (item, offset = false) => {
  scrollIt(document.querySelector(item), 1200, 'easeInOutQuad', offset);
};

export const initAnchorLinks = () => {
  document.querySelectorAll('a[href^="#"]').forEach((link) => {
    link.addEventListener('click', (event) => {
      event.preventDefault();
      const href = link.getAttribute('href');
      if (href.replace('#', '').length) {
        scrollToItem(href, true);
      }
    });
  });
};

export default scrollIt;
